import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import '@/assets/css/tailwind.css'
import '@/assets/css/main.scss'
import '@/assets/css/main_gept.scss'

import '@/assets/css/sweatalert.scss'

import './api.js'
import VueGtm from '@gtm-support/vue2-gtm'
import router from './router'
import store from './store'
import VueSweetalert2 from 'vue-sweetalert2'
import axios from 'axios'
import 'sweetalert2/dist/sweetalert2.min.css'

import VueTypedJs from 'vue-typed-js'

import VueI18n from 'vue-i18n'

import videojs from "video.js"
import "video.js/dist/video-js.css"

import vClickOutside from 'v-click-outside'
import LottieAnimation from 'lottie-web-vue'
import moment from 'moment'
Vue.use(VueGtm, {
  id: 'GTM-K6NPTJH2'
})

Vue.use(vClickOutside)
Vue.prototype.$video = videojs

Vue.use(VueSweetalert2)
Vue.use(VueTypedJs)

import VueMeta from 'vue-meta'

Vue.use(VueMeta)

Vue.use(VueI18n)
Vue.use(require('vue-moment'))
Vue.prototype.moment = moment
let locale = 'zh'
const i18n = new VueI18n({
  locale: locale,
  messages: {
    'zh': require('@/i18n/zh.json'),
    'en': require('@/i18n/en.json')
  }
})

Vue.config.lang = store.state.lang

Vue.prototype.$http = axios

Vue.config.productionTip = false

 
Vue.use(LottieAnimation)
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')



